<template>
  <div id="contact" class="contact-wrap pb-100">
    <div class="container">
      <div class="row gx-5">
        <div class="col-lg-6">
          <div class="contact-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3151.8385385572983!2d144.95358331584498!3d-37.81725074201705!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6ad65d4dd5a05d97%3A0x3e64f855a564844d!2s121%20King%20St%2C%20Melbourne%20VIC%203000%2C%20Australia!5e0!3m2!1sen!2sbd!4v1612419490850!5m2!1sen!2sbd"
            ></iframe>
          </div>
        </div>

        <div class="col-lg-6">
          <div class="content-title style1 mb-20">
            <span>Keep In Touch With Us</span>
            <h2>Contact Information</h2>
          </div>

          <form class="form-wrap" id="contactForm">
            <div class="row">
              <div class="col-lg-6 col-md-6">
                <div class="form-group">
                  <input
                    type="text"
                    name="name"
                    placeholder="Full Name*"
                    id="name"
                    required
                  />
                </div>
              </div>

              <div class="col-lg-6 col-md-6">
                <div class="form-group">
                  <input
                    type="email"
                    name="email"
                    id="email"
                    required
                    placeholder="Email*"
                  />
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <input
                    type="text"
                    name="phone_number"
                    placeholder="Phone*"
                    id="phone_number"
                    required
                  />
                </div>
              </div>

              <div class="col-lg-12">
                <div class="form-group">
                  <input
                    type="text"
                    name="msg_subject"
                    placeholder="Subject*"
                    id="msg_subject"
                    required
                  />
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group v1">
                  <textarea
                    name="message"
                    id="message"
                    placeholder="Your Messages.."
                    cols="30"
                    rows="10"
                    required
                  ></textarea>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <div class="form-check checkbox">
                    <input
                      name="gridCheck"
                      value="I agree to the terms and privacy policy."
                      class="form-check-input"
                      type="checkbox"
                      id="gridCheck"
                      required
                    />
                    <label class="form-check-label" for="gridCheck">
                      I agree to the
                      <router-link class="link style1" to="/terms-of-service">
                        terms &amp; conditions
                      </router-link>
                      and
                      <router-link class="link style1" to="/privacy-policy">
                        privacy policy
                      </router-link>
                    </label>
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <button type="submit" class="btn style1">Send Message</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KeepInTouch",
};
</script>